import { NavLink } from 'react-router-dom';
import { Home, FileText, CheckSquare, Target, User } from 'lucide-react';
import clsx from 'clsx';
import { useDemoContext } from '@/demo/demo-context';

const navItems = [
  { to: '/home', label: 'Home', icon: Home },
  { to: '/entries', label: 'Entries', icon: FileText },
  { to: '/tasks', label: 'Tasks', icon: CheckSquare },
  { to: '/focus', label: 'Focus', icon: Target },
  { to: '/profile', label: 'Profile', icon: User },
];

export function BottomNav() {
  const { getDemoPath } = useDemoContext();
  
  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 safe-area-inset-bottom lg:hidden">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={getDemoPath(item.to)}
            data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
            className={({ isActive }) =>
              clsx(
                'flex flex-col items-center justify-center flex-1 h-full gap-1 text-xs font-medium transition-colors',
                isActive ? 'text-primary-700' : 'text-stone-500'
              )
            }
          >
            {({ isActive }) => (
              <>
                <item.icon
                  className={clsx(
                    'w-5 h-5',
                    isActive ? 'stroke-[2.5]' : 'stroke-[1.5]'
                  )}
                />
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
